import { useMemo } from "react";
import { Box, Text } from "@mantine/core";
import type { LegacyHistoricalReportHeader } from "../../types/legacyHistoricalReport";
import { historicalPatientName } from "./legacyHistoricalReportLayout";

interface Props {
  header: LegacyHistoricalReportHeader;
  continuation: boolean;
}

export function LegacyHistoricalHeader({ header, continuation }: Props) {
  const name = useMemo(() => historicalPatientName(header), [header]);
  const details = useMemo(
    () =>
      [
        ["Date of birth", header.dateOfBirth],
        ["Sex", header.sex],
        ["MRN", header.medicalRecordNumber],
        ["Collected", header.dateCollected],
        ["Received", header.dateReceived],
        ["Reported", header.reportedDateText],
        ["Physician", header.physicianText],
      ].filter((entry) => entry[1]),
    [header]
  );
  return (
    <Box
      mb="8pt"
      data-historical-header="true"
      style={{
        borderBottom: "1px solid var(--mantine-color-gray-5)",
        paddingBottom: "8pt",
        color: "var(--mantine-color-black)",
      }}
    >
      {!continuation && header.laboratoryText && (
        <Text fw={700} size="11pt" style={{ whiteSpace: "pre-wrap" }}>
          {header.laboratoryText}
        </Text>
      )}
      <Text fw={700} size="11pt">
        {name}
      </Text>
      <Text size="10pt">Case: {header.caseNumber}</Text>
      {!continuation &&
        details.map(([label, value]) => (
          <Text key={label} size="10pt" style={{ whiteSpace: "pre-wrap" }}>
            {label}: {value}
          </Text>
        ))}
    </Box>
  );
}
